(function() {
  'use strict';

  var noticeSelector = '[data-cart-discount-notice]';
  var codeSelector = '[data-cart-discount-notice-code]';
  var detailSelector = '[data-cart-discount-notice-detail]';
  var lastDiscountCodes = [];
  var refreshTimer = null;
  var observer = null;

  function normalizeDiscountCode(discount) {
    if (!discount) {
      return '';
    }

    if (typeof discount === 'string') {
      return discount.trim();
    }

    if (typeof discount.code === 'string') {
      return discount.code.trim();
    }

    if (typeof discount.title === 'string') {
      return discount.title.trim();
    }

    return '';
  }

  function extractDiscountCodes(cart) {
    var codes = [];

    if (!cart || typeof cart !== 'object') {
      return codes;
    }

    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function(discount) {
        var code = normalizeDiscountCode(discount);

        if (code && codes.indexOf(code) === -1) {
          codes.push(code);
        }
      });
    }

    if (Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function(discount) {
        var code = normalizeDiscountCode(discount);

        if (code && codes.indexOf(code) === -1) {
          codes.push(code);
        }
      });
    }

    return codes;
  }

  function formatDiscountLabel(codes) {
    if (!codes || codes.length === 0) {
      return '';
    }

    if (codes.length === 1) {
      return codes[0];
    }

    return codes.length + ' codes';
  }

  function getRecentStoredCodes() {
    var pendingDiscountData = sessionStorage.getItem('shopifyPendingDiscount');

    if (!pendingDiscountData) {
      return [];
    }

    try {
      var discountData = JSON.parse(pendingDiscountData);
      var isRecent = discountData.timestamp && Date.now() - discountData.timestamp <= 120000;

      if (isRecent && Array.isArray(discountData.codes)) {
        return discountData.codes.map(normalizeDiscountCode).filter(Boolean);
      }
    } catch (error) {
      return [];
    }

    return [];
  }

  function updateNotices(codes) {
    var discountCodes = Array.isArray(codes) ? codes : [];
    var notices = document.querySelectorAll(noticeSelector);

    lastDiscountCodes = discountCodes;

    notices.forEach(function(notice) {
      var hasDiscountCodes = discountCodes.length > 0;
      var codeElement = notice.querySelector(codeSelector);
      var detailElement = notice.querySelector(detailSelector);

      notice.hidden = !hasDiscountCodes;
      notice.setAttribute('aria-hidden', hasDiscountCodes ? 'false' : 'true');

      if (!hasDiscountCodes) {
        return;
      }

      if (codeElement) {
        codeElement.textContent = formatDiscountLabel(discountCodes);
      }

      if (detailElement) {
        detailElement.textContent = discountCodes.length === 1
          ? 'Applies at checkout'
          : 'Apply at checkout';
      }
    });
  }

  function getCartJsonUrl() {
    var cartUrl = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl
      ? window.themeVariables.routes.cartUrl
      : '/cart';

    return cartUrl.replace(/\/$/, '') + '.js';
  }

  async function refreshFromCart() {
    try {
      var response = await fetch(getCartJsonUrl(), {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        updateNotices(lastDiscountCodes.length > 0 ? lastDiscountCodes : getRecentStoredCodes());
        return;
      }

      var cart = await response.json();
      updateNotices(extractDiscountCodes(cart));
    } catch (error) {
      updateNotices(lastDiscountCodes.length > 0 ? lastDiscountCodes : getRecentStoredCodes());
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromCart, delay || 0);
  }

  function syncAfterDrawerRender() {
    var codes = lastDiscountCodes.length > 0 ? lastDiscountCodes : getRecentStoredCodes();
    updateNotices(codes);
    scheduleRefresh(150);
  }

  function observeCartDrawer() {
    var miniCart = document.getElementById('mini-cart');

    if (!miniCart || typeof MutationObserver === 'undefined') {
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(function() {
      syncAfterDrawerRender();
    });

    observer.observe(miniCart, { childList: true });
  }

  function initCartDiscountNotice() {
    var cartEventTarget = document.documentElement || document;

    updateNotices(getRecentStoredCodes());
    scheduleRefresh(250);
    observeCartDrawer();

    cartEventTarget.addEventListener('cart:refresh', function() {
      scheduleRefresh(900);
    });

    cartEventTarget.addEventListener('cart:updated', function(event) {
      if (event.detail && event.detail.cart) {
        updateNotices(extractDiscountCodes(event.detail.cart));
      } else {
        scheduleRefresh(150);
      }
    });

    cartEventTarget.addEventListener('variant:added', function() {
      scheduleRefresh(900);
    });
  }

  window.DebriefsCartDiscountNotice = {
    extractDiscountCodes: extractDiscountCodes,
    formatDiscountLabel: formatDiscountLabel,
    refresh: refreshFromCart,
    update: updateNotices
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDiscountNotice);
  } else {
    initCartDiscountNotice();
  }
})();
